"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _RadioButtonModule = _interopRequireDefault(require("./RadioButton.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RadioButton = /*#__PURE__*/React.forwardRef((_ref, forwardRef) => {
  let {
    children,
    disabled = false,
    value = '',
    focused = false,
    name = 'radio',
    selectedValue,
    onChange,
    align = 'vertical',
    classNames,
    error = false,
    tabIndex = 0,
    ariaLabel = '',
    ...props
  } = _ref;
  const radioInput = /*#__PURE__*/React.createRef();
  React.useImperativeHandle(forwardRef, () => radioInput.current);
  const checked = selectedValue === value;
  React.useEffect(() => {
    if (radioInput.current && focused) {
      radioInput.current.focus();
    }
  }, [focused]);
  const onWrapClickHandler = () => {
    radioInput.current?.click();
  };
  const onChangeHandler = e => {
    if (!disabled) {
      onChange && onChange(e?.target?.value);
    }
  };
  const onKeyDownHandler = e => {
    if (e.key === 'Enter') {
      onChangeHandler(e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_RadioButtonModule.default.container, {
      [_RadioButtonModule.default.horizontalRadioButton]: align === 'horizontal-fixed',
      [_RadioButtonModule.default.fluidRadioButton]: align === 'horizontal-fluid',
      [_RadioButtonModule.default.containerDisabled]: disabled
    }, classNames?.wrapper),
    onClick: onWrapClickHandler
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "radio",
    checked: checked,
    disabled: disabled,
    className: (0, _classify.default)(_RadioButtonModule.default.radio, {
      [_RadioButtonModule.default.unselected]: !checked && !disabled && !error,
      [_RadioButtonModule.default.selected]: checked && !disabled && !error,
      [_RadioButtonModule.default.disabled]: disabled,
      [_RadioButtonModule.default.error]: error && !disabled
    }, classNames?.radio),
    ref: radioInput,
    onChange: onChangeHandler,
    onKeyDown: onKeyDownHandler,
    tabIndex: disabled ? -1 : tabIndex,
    name: name,
    value: value || '',
    "aria-label": ariaLabel || children
  }, props)), React.Children.count(children) > 0 && /*#__PURE__*/React.createElement("div", {
    color: "secondary",
    className: (0, _classify.default)(_RadioButtonModule.default.radioLabel, {
      [_RadioButtonModule.default.labelDisabled]: disabled
    }, classNames?.label)
  }, children));
});
exports.RadioButton = RadioButton;